// Kid-friendly stubs — familiar flavors, low spice, fun shapes.
// Always-on tag (no date math); surfaces for families.

export const KIDS_STUBS = [
  {
    id: "chicken-tenders",
    title: "Crispy Chicken Tenders",
    emoji: "🍗",
    blurb: "Breaded, oven-baked, dipping sauce trio",
    discoveryTags: ["kids", "weeknight", "comfort-food", "game-day"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 35,
    keyIngredients: ["chicken_breast", "panko", "flour", "eggs", "honey", "mustard"],
    buildHint: "flour → egg → panko 3-step bread, panko toasted gold before breading for color, 425F oven on wire rack for crispy bottoms, honey-mustard + bbq + ranch trio",
    producesCanonical: null,
  },
  {
    id: "personal-pizza",
    title: "Personal Pizza",
    emoji: "🍕",
    blurb: "DIY toppings, kid-sized, family-pleasing",
    discoveryTags: ["kids", "weeknight", "game-day", "comfort-food"],
    cuisine: "italian",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 40,
    keyIngredients: ["pizza_dough", "tomato_sauce", "mozzarella", "pepperoni"],
    buildHint: "preheat oven SCREAMING hot 500F with stone or steel, thin sauce + part-skim mozz for melt, bake 8 min for browned crust, let kid pick toppings",
    producesCanonical: null,
  },
  {
    id: "sloppy-joes",
    title: "Sloppy Joes",
    emoji: "🍔",
    blurb: "Saucy ground beef on a soft bun",
    discoveryTags: ["kids", "weeknight", "comfort-food", "cookout"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 30,
    keyIngredients: ["ground_beef", "onion", "bell_pepper", "ketchup", "bun"],
    buildHint: "brown beef + diced onion + pepper, sauce of ketchup + worcestershire + brown sugar + mustard simmered 10 min thick, scoop onto toasted bun",
    producesCanonical: null,
  },
  {
    id: "spaghetti-and-meatballs",
    title: "Spaghetti and Meatballs",
    emoji: "🍝",
    blurb: "Hand-rolled meatballs, simple tomato sauce",
    discoveryTags: ["kids", "weeknight", "sunday-dinner", "comfort-food"],
    cuisine: "italian",
    course: "main",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 60,
    keyIngredients: ["spaghetti", "ground_beef", "tomato_sauce", "parmesan", "garlic", "bread"],
    buildHint: "meatball mix with milk-soaked breadcrumbs (panade) for tender, brown in batches, simmer in tomato sauce 25 min to finish, serve over al dente spaghetti",
    producesCanonical: null,
  },
];
